import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initOfflineQueue } from "./lib/offline-queue";

// Startup recovery: any action left in "syncing" by a killed replay reverts to
// "pending", and the global replay triggers (online/visibilitychange) wire up.
initOfflineQueue();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
